import { render, staticRenderFns } from "./ShenPiNewFyBxChaiLvEditChaiLv.vue?vue&type=template&id=240dcad2&scoped=true&"
import script from "./ShenPiNewFyBxChaiLvEditChaiLv.vue?vue&type=script&lang=js&"
export * from "./ShenPiNewFyBxChaiLvEditChaiLv.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiNewFyBxChaiLvEditChaiLv.vue?vue&type=style&index=0&id=240dcad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240dcad2",
  null
  
)

export default component.exports